<template>
  <div class="card">
    <div class="card-body mb-0 pb-0">
      <div class="row">
        <div class="col-lg-11" style="margin:0 auto">
          <base-button type="primary" size="lg" class="btn-fill mr-2 pull-right" v-on:click="exportEvaluation(application.id)">
            Export evaluation
          </base-button>
        </div>
      </div>
    </div>
    <div class="card-body mt-0 pt-0" id="evaluationGrid">
      <div class="row">
        <div class="col-lg-11" style="margin:0 auto">
          <div>
            <h4 class="card-title font-weight-bold mt-4">Consolidated Grid Report -
              <span v-if="application">{{application.reference_nr}}</span></h4>
          </div>
          <div>
            <!-- <table class="table-bordered border-left-0 border-right-0 table-full-width mt-3" cellpadding="20">
              <tr>
                <td>
                  <div class="d-flex">
                    <h4 class="card-title font-weight-bold mb-0 d-inline mr-5">{{$t('reports.due_diligence_risk')}}:
                      <span class="ml-2 font-weight-normal">{{diligenceRisk.toUpperCase()}}</span></h4>
                    <h4 class="card-title font-weight-bold mb-0 d-inline ml-5">{{$t('reports.esms_risk')}}:
                      <span class="ml-2 font-weight-normal">{{esmsRisk.toUpperCase()}}</span></h4>
                  </div>
                </td>
                <td>
                  <h4 class="card-title font-weight-bold">
                    TOTAL: <span>{{totalScore}}</span>
                  </h4>
                </td>
              </tr>
            </table> -->
            <application-info v-if="application" :application="application" :evaluations="evaluations"></application-info>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {ReportsService} from "@/services";
  import {ExportEvaluation} from 'src/components';
  import ApplicationInfo from "./ApplicationInfo";
  import {Select, Option} from 'element-ui';
  import {CommentBox} from 'src/components';

  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      ExportEvaluation,
      CommentBox,
      ApplicationInfo
    },
    data() {
      return {
        application: {},
        evaluations: [],
        final_comments: [],
        diligence_evaluation: null,
        esms_evaluation: null,
        applicationId: parseInt(this.$route.params.applicationId)
      }
    },
    computed: {
      diligenceRisk() {
        let vm = this;
        if (!vm.diligence_evaluation) {
          return '-';
        }

        let total_score = vm.total_score();
        if (total_score <= 25) {
          return this.$t('medium_grant_ev.diligence__info_risk_low');
        } else if (total_score > 25 && total_score <= 40) {
          return this.$t('medium_grant_ev.diligence__info_risk_medium');
        } else if (total_score > 40) {
          return this.$t('medium_grant_ev.diligence__info_risk_high');
        }
      },
      esmsRisk() {
        let vm = this;
        if (!vm.esms_evaluation) {
          return '-';
        }

        let evmodel = vm.esms_evaluation.model.info_risk_assessment;
        if (evmodel === 'verified') {
          return this.$t('medium_grant_ev.esms__info_low');
        } else if (evmodel === 'unverifiable') {
          return this.$t('medium_grant_ev.esms__info_medium');
        } else if (evmodel === 'clarification') {
          return this.$t('medium_grant_ev.esms__info_high');
        }
      },
      totalScore() {
        let vm = this;

        let total = 0;
        vm.evaluations.forEach(function(item) {
          total += item.total_score;
        })

        if(vm.evaluations.length) {
          total = (total / vm.evaluations.length);
        }

        if(total === 0) {
          return '-';
        } else {
          return total.toFixed(0);
        }
      }
    },
    methods: {
      async getEvaluation() {
        let vm = this;
        let loader = vm.$loading.show();

        await ReportsService.getEvaluation(vm.applicationId).then(function (response) {
          let result = response.data;

          vm.application = result.application;
          vm.evaluations = result.technical;
          vm.final_comments = result.final_comments;

          vm.application.evaluations.forEach(function (evaluation) {
            if (evaluation.type.nickname === 'diligence') {
              vm.diligence_evaluation = evaluation;
            } else if (evaluation.type.nickname === 'esms') {
              vm.esms_evaluation = evaluation;
            }
          })
        })

        loader.hide();
      },
      exportEvaluation(user_id, name)
      {
        let vm = this;
        let loader = vm.$loading.show();

        console.log(user_id);

        ReportsService.exportEvaluation({
          user_id: user_id,
        }).then((response) => {
          if (response.data && response.data.success)
          {
            window.open(response.data.url, '_blank');
          }

          loader.hide();
        });
      },
    },
    mounted() {
      let vm = this;
      vm.getEvaluation();
    }
  }
</script>
<style scoped>
  textarea {
    resize: vertical !important;
  }

  .border-top-big {
    border-top: 2px solid black;
  }
</style>